import type { Address } from '@/modules/cart/domain/Address';
import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

const SHIPPING_ADDRESS_URL = `${CART_URL}/shipping-address`;

const expandParam =
  'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';

const POST_SHIPPING_ADDRESS_URL = `${SHIPPING_ADDRESS_URL}?expand=${expandParam}`;

export async function createShippingAddress(
  address: Omit<Address, 'id'>
): Promise<{ data: HttpCartDto }> {
  return await httpClient.post(POST_SHIPPING_ADDRESS_URL, {
    ...address,
    apartment: address?.apartment ?? address.additionalStreetInfo ?? '',
    country: 'CL',
    region: address?.region + ''
  });
}
